import { render } from "./StakeNative.vue?vue&type=template&id=25a37696"
import script from "./StakeNative.vue?vue&type=script&lang=js"
export * from "./StakeNative.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeNative.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25a37696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25a37696', __exports__)) {
    api.reload('25a37696', __exports__)
  }
  
  module.hot.accept("./StakeNative.vue?vue&type=template&id=25a37696", () => {
    api.rerender('25a37696', render)
  })

}


export default __exports__